<script>
  import Skeleton from '@/widgets/skeleton/Skeleton.svelte';
  const baseColor = '#eaeaea';
</script>

<style>
  .item {
    box-sizing: border-box;
    border-left: 1px solid #e2e4e9;
    padding: 0 20px;
  }
  .item:first-child {
    border-left: none;
  }
  .fs0 {
    flex-shrink: 0;
  }
</style>

<div class="item df cp">
  <div class="fs0 mr12">
    <Skeleton width="32px" height="32px" {baseColor} />
  </div>
  <div class="wp100">
    <Skeleton height="20px" width="80px" {baseColor} />
    <Skeleton height="12px" {baseColor} />
  </div>
</div>
